import { render } from "./Element.vue?vue&type=template&id=ed3a4ef6&scoped=true"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"

import "./Element.vue?vue&type=style&index=0&id=ed3a4ef6&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3a4ef6"]])

export default __exports__